"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var wildfires_1 = __importDefault(require("./wildfires"));
var map_1 = __importDefault(require("./map"));
var UI_1 = __importDefault(require("./UI"));
exports.default = redux_1.combineReducers({
    wildfires: wildfires_1.default,
    map: map_1.default,
    ui: UI_1.default
});
